import React, { Component } from 'react'
import { priceStandardView, translate } from '../../utils/useful';
import Collapsible from 'react-collapsible';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import moment from 'moment';
export class CartSuccess extends Component {

    state = {
        collapse: true,
    }

    componentDidMount() { }

    changeCollapse = () => {
        let collapse = this.state.collapse
        collapse = !collapse
        this.setState({ collapse })
    }

    render() {
        let colors = this.props.colors
        let background = `linear-gradient(90deg, ${colors?.primaryColor}, ${colors?.secondaryColor})`
        let cart = {}
        if (this.props.carts?.applets) {
            cart = this.props.carts?.applets[this.props.variables?.appletId]
        }

        return (
            <div className='w-100 window-content-radius h-100 d-flex flex-column scroll-no-scrollbar pb-5' style={{ background: "#f6f6f6" }}>

                <div className='flexcc mt-3'>


                    <div className='mx-3 mb-2 w-100' style={{ maxWidth: '450px' }}>


                        <div className='px-4 br-10 py-3 flexcb bg-white  '>
                            <div className='w-100 flexcc flex-column'>
                                <img src='/assets/icons/success.svg' style={{ width: '80px' }} />
                                <p className='text-normal weight-600 main-c2 pt-2'>{translate('Payment Success!')}</p>
                                <p className='text-bold text-semibig pt-2'>{this.props.paymentIntent?.currency + ' ' + priceStandardView(this.props.paymentIntent?.amount)}</p>
                            </div>

                        </div>


                        <div className=' mb-3 mt-3 px-4 py-3 br-10 ' style={{ backgroundColor: "#fff" }}>
                            <div className='flexcb w-100'>
                                <p className='text-bold text-normal main-c2'>{translate("Payment Details")}</p>
                                <button className={'flexcc transition ' + (this.state.collapse ? 'rotate-270' : '')} onClick={() => { this.changeCollapse() }}>
                                    <img src={'/assets/icons/tower/arrow-right.svg'} width={20} />
                                </button>
                            </div>
                            <Collapsible open={this.state.collapse} transitionTime={500}>
                                <div className='mt-3'>
                                    <div className='flexcb w-100 py-2'>
                                        <p className='text-small weight-500 main-c2 opacity-7'>{translate('Date')}</p>
                                        <p className='text-small weight-500 main-c2'>{moment(1737963603 * 1000).format('MMM DD, YYYY')}</p>
                                    </div>
                                    <div className='flexcb w-100 py-2'>
                                        <p className='text-small weight-500 main-c2 opacity-7'>{translate('Time')}</p>
                                        <p className='text-small weight-500 main-c2'>{moment(1737963603 * 1000).format('hh:MM A')}</p>
                                    </div>
                                    <div className='flexcb w-100 py-2'>
                                        <p className='text-small weight-500 main-c2 opacity-7'>{translate('Status')}</p>
                                        <p className='text-small weight-500 main-c2'>{translate(this.props.paymentIntent?.status)}</p>
                                    </div>
                                    <div className='flexcb w-100 pb-2 pt-3 mt-3' style={{ borderTop: '2px dashed #eee' }}>
                                        <p className='text-small weight-500 main-c2 opacity-7'>{translate('Amount')}</p>
                                        <p className='text-small weight-500 main-c2'>{this.props.paymentIntent?.currency + ' ' + priceStandardView(this.props.paymentIntent?.amount)}</p>
                                    </div>
                                </div>
                            </Collapsible>
                        </div>
                        <button onClick={() => { this.props.changePage('') }} className='w-100 py-3 px-2' style={{ borderRadius: 100, background: this.props.colors?.background ?? "linear-gradient(90deg, #184D94, #246AC7)" }}>
                            <p className='text-small weight-600' style={{ color: this.props.colors?.textColor ?? '#fff' }}>{translate('Done')}</p>
                        </button>
                    </div>



                </div >
            </div >
        )
    }
}




const mapStateToProps = state => ({ carts: state.carts, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CartSuccess);